import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPopup } from "../popupModel";
import moment from "moment";

export const getAllPopup = createAsyncThunk(
  "Popup/FindAllPopup",
  async (title?: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Popup/FindAllPopup`,
        {
          Title: title ?? "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Popup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPopup = createAsyncThunk(
  "Popup/InsertPopup",
  async (popupData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Popup/InsertPopup`,
        popupData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Popup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePopup = createAsyncThunk(
  "Popup/UpdatePopup",
  async (popupData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Popup/UpdatePopup`,
        popupData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Popup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePopup = createAsyncThunk(
  "Popup/DeletePopup",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Popup/DeletePopup`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Popup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPopupByID = createAsyncThunk(
  "Popup/FindByIDPopup",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Popup/FindByIDPopup`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        URL: result.URL,
        StartDate: result.StartDate
          ? moment(result.StartDate, "YYYY-MM-DD").toDate()
          : "",
        EndDate: result.EndDate
          ? moment(result.EndDate, "YYYY-MM-DD").toDate()
          : "",
        IsActive: result.IsActive ? 1 : 2,
        ImageUpload: result.ImageUpload,
      } as IPopup;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Popup by ID:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActivePopup = createAsyncThunk(
  "Popup/FindAllActivePopup",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Popup/FindAllActivePopup`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Popups:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactivePopup = createAsyncThunk(
  "Popup/ActiveInActivePopup",
  async (data: { ID: number; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Popup/ActiveInActivePopup`,
        data,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Popup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const uploadPopupImage = createAsyncThunk(
  "Popup/UploadImagePopup",
  async (formData: FormData) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Popup/UploadImagePopup`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading Popup image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
